import { ApiError, ApiErrorCode, ApiErrorPayload } from './types';

export function isErrorCode<Code extends ApiErrorCode = ApiErrorCode>(
  code: Code,
  error: ApiError,
): error is ApiError<ApiErrorPayload<Code>> {
  return error.error.code === code;
}
